import { render, staticRenderFns } from "./smart-routing.vue?vue&type=template&id=b6d2326a&scoped=true&"
import script from "./smart-routing.vue?vue&type=script&lang=js&"
export * from "./smart-routing.vue?vue&type=script&lang=js&"
import style0 from "./smart-routing.vue?vue&type=style&index=0&id=b6d2326a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d2326a",
  null
  
)

export default component.exports